import { Button, Card, Col, Table, theme } from 'antd'
import React from 'react'
import CustomRow from '../../../reusable-components/CustomRow'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { hexToRGBA } from '../../../lib/utils'

const Summary = ({
  general,
  data,
  visits,
  isMonitoring,
  setCurrentStep,
  planType,
  planLabel,
  generalData,
  visitsData,
  trackersData,
  medicationsData = [],
  diagnosticsData = [],
  additionalSections = []
}) => {
  const { token } = theme.useToken()

  // Use provided data or fallback to the parameters
  const generalInfo = generalData || general
  const trackersInfo = trackersData || data
  const visitsInfo = visitsData || visits

  // Display the correct plan type in UI
  const displayLabel =
    planLabel || (planType ? planType.charAt(0).toUpperCase() + planType.slice(1) + ' Plan' : 'Care Plan')

  return (
    <Card size='small'>
      <CustomRow>
        <Col span={8}>
          <Card
            headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
            size='small'
            title='General'
            extra={
              <Button type='primary' onClick={() => setCurrentStep(0)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            }
          >
            <h1>{generalInfo.name || <span style={{ color: token.colorError }}>NO NAME PROVIDED</span>} </h1>
            <p>
              {generalInfo.description || <span style={{ color: token.colorError }}>No description provided</span>}{' '}
            </p>
          </Card>
        </Col>
        <Col span={16}>
          <Card
            title={`${planType === 'health' ? 'Health' : trackersInfo.title || 'Data'} Trackers`}
            headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
            size='small'
            extra={
              <Button type='primary' onClick={() => setCurrentStep(1)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            }
          >
            {trackersInfo.length === 0 ? (
              <p style={{ color: token.colorError }}>
                No {planType === 'health' ? 'Health' : 'Data'} Trackers selected.
              </p>
            ) : (
              <Table
                size='small'
                pagination={false}
                showHeader={false}
                columns={[{ title: 'Tracker', dataIndex: 'dataLabel' }]}
                dataSource={trackersInfo}
              />
            )}
          </Card>
          {!isMonitoring ? (
            <Card
              onClick={() => setCurrentStep(2)}
              title='Visit Trackers'
              style={{ marginTop: 12 }}
              headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
              size='small'
              extra={
                <Button type='primary'>
                  <FontAwesomeIcon icon={faEdit} />
                </Button>
              }
            >
              {visitsInfo.length === 0 ? (
                <p style={{ color: token.colorError }}>No Visit Trackers selected.</p>
              ) : (
                <Table
                  size='small'
                  pagination={false}
                  showHeader={false}
                  columns={[{ title: 'Visit', dataIndex: 'dataLabel' }]}
                  dataSource={visitsInfo}
                />
              )}
            </Card>
          ) : undefined}

          {planType === 'treatment' && (
            <>
              <Card
                onClick={() => setCurrentStep(3)}
                title='Medications'
                style={{ marginTop: 12 }}
                headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
                size='small'
                extra={
                  <Button type='primary'>
                    <FontAwesomeIcon icon={faEdit} />
                  </Button>
                }
              >
                {medicationsData.length === 0 ? (
                  <p style={{ color: token.colorError }}>No Medications added.</p>
                ) : (
                  <Table
                    size='small'
                    pagination={false}
                    showHeader={false}
                    columns={[{ title: 'Medication', dataIndex: 'name' }]}
                    dataSource={medicationsData}
                  />
                )}
              </Card>

              <Card
                onClick={() => setCurrentStep(4)}
                title='Diagnostic Tests'
                style={{ marginTop: 12 }}
                headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
                size='small'
                extra={
                  <Button type='primary'>
                    <FontAwesomeIcon icon={faEdit} />
                  </Button>
                }
              >
                {diagnosticsData.length === 0 ? (
                  <p style={{ color: token.colorError }}>No Diagnostic Tests added.</p>
                ) : (
                  <Table
                    size='small'
                    pagination={false}
                    showHeader={false}
                    columns={[{ title: 'Test', dataIndex: 'testName' }]}
                    dataSource={diagnosticsData}
                  />
                )}
              </Card>
            </>
          )}

          {/* Render additional sections if provided */}
          {additionalSections &&
            additionalSections.length > 0 &&
            additionalSections.map((section, index) => (
              <Card
                key={index}
                onClick={() => setCurrentStep(index + 3)} // +3 to account for General, Visits, etc.
                title={section.title || `Section ${index + 1}`}
                style={{ marginTop: 12 }}
                headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
                size='small'
                extra={
                  <Button type='primary'>
                    <FontAwesomeIcon icon={faEdit} />
                  </Button>
                }
              >
                {!section.data || section.data.length === 0 ? (
                  <p style={{ color: token.colorError }}>No data available.</p>
                ) : (
                  <Table
                    size='small'
                    pagination={false}
                    showHeader={false}
                    columns={[{ title: 'Item', dataIndex: 'name' }]}
                    dataSource={section.data}
                  />
                )}
              </Card>
            ))}
        </Col>
      </CustomRow>
    </Card>
  )
}

export default Summary
